<template>
  <div class="flow-detail">
    <el-tabs type="card" class="diagram-content_tab" v-model="activeTab">
      <el-tab-pane
        label="当前流程"
        name="current"
        class="diagram-content_current"
      >
        <block title="审批流程" :editable="false" class="block">
          <detail-flow
            :flows="[form.activityModel.activitiNodeDetails]"
            :data-status="form.status"
          ></detail-flow>
        </block>
        <block title="基本信息" :editable="false" class="basic-info">
          <el-form>
            <el-form-item label="姓名">
              {{ form.staffName }}
            </el-form-item>
            <el-form-item label="手机号">
              {{ form.mobile }}
            </el-form-item>
            <el-form-item label="部门">
              {{ form.sysDeptName && form.sysDeptName.deptName }}
            </el-form-item>
            <el-form-item label="岗位">
              {{
                form.sysPositionNameList &&
                form.sysPositionNameList.map((e) => e.positionName).join(",")
              }}
            </el-form-item>
            <el-form-item label="入职日期">
              {{ form.entryTime || "无" }}
            </el-form-item>
            <el-form-item label="劳动合同主体">
              {{ form.contractsPartA || "无" }}
            </el-form-item>
            <el-form-item label="是否为经理人">
              {{ form.isManager ? "是" : "否" }}
            </el-form-item>
            <el-form-item label="是否为党员">
              {{ form.joinPartyTime ? "是" : "否" }}
            </el-form-item>
          </el-form>
        </block>
      </el-tab-pane>
      <el-tab-pane
        label="历史记录"
        name="history"
        class="diagram-content_history"
        v-if="['initiation', 'agent'].includes(this.type)"
      >
        <template v-if="historyRecord && historyRecord.length">
          <div
            class="record-item"
            v-for="(record, index) in historyRecord"
            :key="index"
            style="border: 1px solid lightgray; margin: 16px; padding: 16px"
          >
            <block title="审批流程" :editable="false" class="block">
              <detail-flow
                :flows="[record.activityModel.activitiNodeDetails]"
                :data-status="record.status"
              ></detail-flow>
            </block>
            <block title="基本信息" :editable="false" class="basic-info">
              <el-form>
                <el-form-item label="姓名">
                  {{ record.staffName }}
                </el-form-item>
                <el-form-item label="手机号">
                  {{ record.mobile }}
                </el-form-item>
                <el-form-item label="部门">
                  {{ record.sysDeptName && record.sysDeptName.deptName }}
                </el-form-item>
                <el-form-item label="岗位">
                  {{
                    record.sysPositionNameList &&
                    record.sysPositionNameList
                      .map((e) => e.positionName)
                      .join(",")
                  }}
                </el-form-item>
                <el-form-item label="入职日期">
                  {{ record.entryTime || "无" }}
                </el-form-item>
                <el-form-item label="劳动合同主体">
                  {{ record.contractsPartA || "无" }}
                </el-form-item>
                <el-form-item label="是否为经理人">
                  {{ record.isManager ? "是" : "否" }}
                </el-form-item>
                <el-form-item label="是否为党员">
                  {{ record.joinPartyTime ? "是" : "否" }}
                </el-form-item>
              </el-form>
            </block>
          </div>
        </template>
        <template v-else>
          <div class="no-record-data">暂无数据</div>
        </template>
      </el-tab-pane>
    </el-tabs>

    <div class="operation-wrapper">
      <div class="operation">
        <el-button @click="back" size="medium">返回</el-button>
        <el-button
          @click="reject"
          type="danger"
          v-if="['agent'].includes(type)"
          size="medium"
          >驳回</el-button
        >
        <el-button
          @click="agree"
          type="primary"
          v-if="['agent'].includes(type)"
          size="medium"
          >通过</el-button
        >
      </div>
    </div>

    <div style="height: 76px"></div>

    <template>
      <!-- 弹出框 -->
      <el-dialog title="提示" :visible.sync="dialogVisible">
        <el-form>
          <el-form-item
            :label="rejectType == 1 ? '驳回理由' : '通过理由'"
            required
            class="dialog-content"
          >
            <el-input
              type="textarea"
              :rows="5"
              :placeholder="
                '请输入' + (rejectType == 1 ? '驳回' : '通过') + '理由'
              "
              v-model="textarea"
              maxlength="80"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import DetailFlow from "@/components/detail-flow";
import Block from "@/components/block";
export default {
  // 入职流转单审批详情
  name: "FlowDetail",
  components: {
    Block,
    DetailFlow,
  },
  data() {
    return {
      historyRecord: [],
      activeTab: "current",
      dialogVisible: false,
      activities: [],
      rejectType: "1",
      textarea: "",
      type: "",
      form: {
        activityModel: {
          activitiNodeDetails: [],
        },
      },
    };
  },
  props: ["id", "taskId"],
  methods: {
    back() {
      this.$emit("changeType");
    },
    reject() {
      this.rejectType = 1;
      this.dialogVisible = true;
    },
    agree() {
      // 通过
      this.rejectType = 2;
      this.dialogVisible = true;
    },
    confirm() {
      if (!this.textarea) {
        this.$message.error(
          this.rejectType == 1 ? "请填写驳回理由" : "请填写通过理由"
        );
        return;
      }
      if (this.rejectType == 1) {
        this.$api.checkapi
          .rejectMyAppply({
            id: this.form.id,
            taskId: this.taskId,
            reason: this.textarea,
            typeId: 6,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$emit("changeType", true);
            }
          });
      } else {
        this.$api.checkapi
          .passMyAppply({
            id: this.form.id,
            taskId: this.taskId,
            reason: this.textarea,
            typeId: 6,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$emit("changeType", true);
            }
          });
      }
    },
    handleData(res) {
      if (res.code == 200) {
        this.form = res.data;
        this.form.activityModel.activitiNodeDetails.forEach((e) => {
          if (e.dealType === "0") {
            // 表示通过，应该为蓝色
            e.color = "#5b69fe";
          } else if (e.dealType === "1") {
            e.color = "#d9001b";
          }
        });
      }
    },
  },
  created() {
    this.type = this.$attrs.type;
    let funcRes;
    if (this.taskId) {
      funcRes = this.$api.personnel.approvalPersonOperationWaitGet(this.taskId);
    } else {
      funcRes = this.$api.personnel.approvalPersonOperationProcessGet(this.id);
    }
    funcRes.then((res) => {
      if (res.data.hasHistory) {
        this.$api.personnel
          .approvalPersonOperationGetHistory({ id: this.id })
          .then(({ data }) => {
            this.historyRecord = data.list;
          });
      }
      this.handleData(res);
    });
  },
};
</script>

<style lang="scss" scoped>
.flow-detail {
  background-color: white;
  .approval-sign {
  }
  .operation-wrapper {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: calc(100% - 242px);
    left: 241px;
    box-sizing: border-box;
    height: 68px;
    z-index: 10;
    text-align: center;
    .operation {
      padding: 16px;
      margin: 0 20px;
    }
  }
  .block {
    background-color: white;
    padding: 20px;
    margin-bottom: 20px;
  }
  .remark {
    color: gray;
    margin-top: 4px;
  }
  .basic-info {
    .el-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 50%;
        flex-shrink: 0;
        display: flex;
      }
    }
  }
}
</style>

<style lang="scss">
.dialog-content {
  flex-grow: 1;
}
</style>